import axios from 'axios';

const BASE_URL = '/agentless_sessions';

export function getAgentlessSessions(params) {
  return axios.get(BASE_URL, { params: params });
}

export function getAgentlessAvailability() {
  return axios.get(`${BASE_URL}/availability`);
}

// Mints a short-lived signed URL; the recording itself streams from the gateway.
// Pass { format: 'mp4' } for the convert-and-download variant.
export function getRecordingUrl(appSessionId, params) {
  return axios.get(`${BASE_URL}/${appSessionId}/recording_url`, { params: params });
}

// backend GeneralError bodies are the react-intl id itself
export function agentlessErrorId(error, fallback) {
  const body = error?.response?.data;
  return typeof body === 'string' && body ? body : fallback;
}
